import { StoreProps } from '@interfaces/StoreState'

export const selectLearningPath = (state: StoreProps) => state.activeState.learningPath
